import React, { useEffect, useState } from "react";
import { BsFillBuildingFill } from "react-icons/bs";
import {
  FaHome,
  FaUser,
  FaPhone,
  FaArrowsAlt,
  FaBed,
  FaCheckCircle,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaTag,
  FaRupeeSign,
  FaEdit,
  FaTrash,
  FaSpinner,
  FaDollarSign,
  FaInfoCircle,
  FaLock,
  FaMobileAlt,
  FaRulerCombined,
  FaMoneyBill,
} from "react-icons/fa";
import { MdClose, MdOutlineHistory } from "react-icons/md";
import { TbCurrencyRupee } from "react-icons/tb";
import { Property } from "../../hook/types/property";
import { useUsers } from "../../hook/useUsers";
import { User } from "../../hook/types/users";

const PropertyCard = ({
  property,
  onClick,
  onOpenPopup,
  handleEdit,
  handleDelete,
}: {
  onOpenPopup: () => void;
  property: Property;
  handleEdit: () => void;
  handleDelete: () => void;
  onClick: () => void;
}) => {
  const {queryClient} = useUsers()
  const uid = localStorage.getItem("R_M_uid") 
  const userData = queryClient.getQueryData(["users",uid])  as User;

  return (
    <div className="relative  hover:border-primary border-2 bg-white rounded-3xl shadow-lg overflow-hidden w-full group">
      {" "}
      {/* Hover effect on card */}
      <img
        src={property.propertyImageUrl as any}
        alt={property.propertyName}
        className="w-full h-64 object-cover"
      />
      <div className="absolute flex flex-col top-0 left-0 p-4 w-72 rounded-br-3xl bg-black bg-opacity-35">
        {/* Property Name */}
        <div className="flex items-center">
          <h2 className="text-white text-xl  truncate">
            {property.propertyName}
          </h2>
        </div>

        {/* Occupier Name */}
        {property.tenantName && (
        <div className="flex text-md items-center gap-2">
          <FaUser className="text-white" />
          <span className="text-white">
            {property.tenantName}
            
          </span>
        </div>
        )}
        {/* Occupier Phone */}
        {property.tenantContact && (
        <div className="flex text-sm items-center gap-2">
          <FaPhone className="text-white" />
          <span className="text-md text-white">
            {property.tenantContact}
          </span>
        </div>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-6 flex justify-between items-center">
        <button
          className="bg-primary text-white font-semibold py-3 px-6 rounded-full shadow-md hover:bg-opacity-80 transition duration-300" // Hover effect for button
          onClick={onClick}
        >
          View Details
        </button>

        <button className="bg-white text-black p-3 flex gap-1 justify-center items-center rounded-full shadow-md hover:bg-gray-200 transition duration-300">
          <TbCurrencyRupee />
          {property.propertyRent} {/* Hover effect for button */}
        </button>
        <button
          onClick={() => {
            onOpenPopup();
          }} // Define this function to handle delete action
          className="rounded-xl hover:border-primary hover:text-primary bg-white hover:bg-primary/10 border p-2"
          title="payment history "
        >
          <MdOutlineHistory className="h-8 hover:text-primary  text-slate-700 w-8 " />
        </button>
      </div>
      {/* Edit and Delete Icons */}
      {userData?.roles[0]?.roleName==='ADMIN'?
       <div className="absolute top-4 right-4 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
       <button
         className="bg-white text-black rounded-full p-2 shadow-md hover:bg-gray-200 transition duration-300"
         onClick={handleEdit} // Define this function to handle edit action
       >
         <FaEdit className="text-lg" />
       </button>
     
       <button
         className="bg-red-500 text-white rounded-full p-2 shadow-md hover:bg-red-600 transition duration-300"
         onClick={handleDelete} // Define this function to handle delete action
       >
         <FaTrash className="text-lg" />
       </button>
     </div>:null}
     
    </div>
  );
};

const PropertyPopup = ({
  property,
  onClose,
}: {
  property: Property;
  onClose: () => void;
}) => {
  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white flex flex-col gap-4 p-6 rounded-lg w-full max-w-md md:max-w-lg lg:max-w-xl">
     <span className="flex justify-between w-full ">
     <p className="text-primary  w-full text-xl font-bold">Properties Details</p>
        <button className="text-red-500 text-xl hover:bg-red-100 flex justify-center items-center rounded-full w-10" onClick={onClose}>
          <MdClose />
        </button>
     </span>
        <div className="flex flex-col md:flex-row gap-4">
          <img
            className="w-full rounded-md h-64 object-cover mb-4 md:mb-0 md:w-1/2"
            src={property.propertyImageUrl as any}
            alt={property.propertyName}
          />
          <div className="w-full  md:w-1/2">
            <div className="text-lg font-bold truncate">{property.propertyName}</div>
            <p className="flex items-center"><FaMapMarkerAlt className="mr-2 flex-shrink-0" /> Address: {property.propertyAddress}</p>
            <p className="flex items-center"><FaHome className="mr-2" /> Type: {property.propertyType}</p>
            <p className="flex items-center"><FaRupeeSign className="mr-2" /> Rent: ₹{property.propertyRent}</p>
            <p className="flex items-center"><FaInfoCircle className="mr-2" /> Status: {property.propertyStatus}</p>
            {property.noOfRooms !== null && property.noOfRooms !== 0 && (
            <p className="flex items-center"><FaBed className="mr-2" /> Rooms: {property.noOfRooms}</p> )}
            {/* <p className="flex items-center"><FaBed className="mr-2" /> Rooms: { property.noOfRooms && ( {property.noOfRooms}</p>  */}
            <p className="flex items-center"><FaMoneyBill className="mr-2" /> Deposit: ₹{property.propertyDepositAmount}</p>
           {property.propertySize !== null && property.propertySize !== 0 && ( <p className="flex items-center"><FaRulerCombined className="mr-2" /> Size: {property.propertySize} sq ft</p> )}
            {/* <p className="flex items-center"><FaMobileAlt className="mr-2" /> Mobile: {property.tenantContact}</p> */}
            <p className={`font-bold mt-4 ${property.isActive ? "text-green-500" : "text-red-500"}`}>
              {property.isActive ? "Active" : "Inactive"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const PropertyList = ({
  setEdit,
  setActiveId,
  loading,
  onOpenPopup,
  properties,
  handleEdit,
  handleDelete,
}: {
  onOpenPopup: () => void;
  setActiveId: (value: any) => void;
  setEdit: (value: boolean) => void;
  handleEdit: (item: any, id: any) => void;
  loading: boolean;
  handleDelete: () => void;
  properties: Property[];
}) => {
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(
    null
  );

  ////------
  const [localProperties, setLocalProperties] = useState<Property[]>(properties);

  // Update local properties when the `properties` prop changes
  useEffect(() => {
    setLocalProperties(properties);
  }, [properties]);

  const handleEditProperty = async (item: Property, id: string) => {
    try {
      await handleEdit(item, id); // Call the API to update the property
      
      // Update the local state
      setLocalProperties((prev) =>
        prev.map((property) =>
          property.id === Number(id) ? { ...property, ...item } : property
        )
      );
    } catch (error) {
      console.error("Error updating property:", error);
    }
  };
  ////------

  if (loading) {
    return (
      <div className="h-full w-full justify-center flex items-center">
        <p className="flex gap-1 justify-center   text-black items-center">
          <FaSpinner className="animate-spin mr-2" /> Loading...
        </p>
      </div>
    );
  }

  if (properties.length==0) {
    return (
      <div className="h-full w-full text-black justify-center flex items-center">
      <p>No Data</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
      {properties.map((property) => (
        <PropertyCard
        
          onOpenPopup={() => {
            onOpenPopup();
            setActiveId(property.id);
          }}
          key={property.id}
          property={property}
          onClick={() => setSelectedProperty(property)}
          handleEdit={() => {
            handleEdit(property, property.id);
            setActiveId(property.id);
            setEdit(true);
          }}
          handleDelete={() => {
            setActiveId(property.id);
            handleDelete();
          }}
        />
      ))}

      {selectedProperty && (
        <PropertyPopup
          property={selectedProperty}
          onClose={() => setSelectedProperty(null)}
        />
      )}
    </div>
  );
};
export default PropertyList;
